import VueRouter from 'vue-router';
import { publicPath } from '@/../vue.config';
import AuthorizeComponent from '@/components/Authorize';
import ContactUsComponent from '@/components/ContactUs';
import ErrorComponent from '@/components/Error';
import ForgotPasswordComponent from '@/components/ForgotPassword';
import ForgotPasswordConfirmationComponent from '@/components/ForgotPasswordConfirmation';
import LoginComponent from '@/components/Login';
import NotFoundComponent from '@/components/NotFound';
import UpdatePasswordComponent from '@/components/UpdatePassword';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginComponent,
    props: route => ({
      redirectUri: route.query.redirect_uri,
      providerUri: route.query.provider_id
        ? route.query.redirect_uri + '&provider_id=' + route.query.provider_id
        : null,
      brandTemplate: route.query.brand_template
    })
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordComponent,
    props: true
  },
  {
    path: '/forgot-password-confirmation',
    name: 'ForgotPasswordConfirmation',
    component: ForgotPasswordConfirmationComponent
  },
  {
    path: '/update-password',
    name: 'UpdatePassword',
    component: UpdatePasswordComponent,
    props: route => ({
      token: route.query.token,
      redirectUri: route.query.redirect_uri,
      brandTemplate: route.query.brand_template
    })
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: ContactUsComponent,
    props: route => ({
      brandTemplate: route.query.brand_template
    })
  },
  {
    path: '/authorize',
    name: 'Authorize',
    component: AuthorizeComponent
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorComponent
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFoundComponent
  }
];

const router = new VueRouter({
  mode: 'history',
  base: publicPath,
  routes
});

export function useRouter () { return router; }

export default router;
